module.exports = __webpack_public_path__ + "media/assets/images/solutions/back_office/hero_image-ba04892afdf2d6a5c99845d49d144f5c.png";